import { action } from "typesafe-actions";
import { IOrgEnvConfig } from "./orgEnvConfig.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";

export const FETCH_ORG_ENV_CONFIG_LIST_PROGRESS =
  "FETCH_ORG_ENV_CONFIG_LIST_PROGRESS";
export const FETCH_ORG_ENV_CONFIG_LIST_SUCCESS =
  "FETCH_ORG_ENV_CONFIG_LIST_SUCCESS";
export const FETCH_ORG_ENV_CONFIG_LIST_FAILED =
  "FETCH_ORG_ENV_CONFIG_LIST_FAILED";

export const fetchOrgEnvConfigListProgress = () =>
  action(FETCH_ORG_ENV_CONFIG_LIST_PROGRESS);
export const fetchOrgEnvConfigListSuccess = (
  data: IOrgEnvConfig[],
  totalRecords: number
) => action(FETCH_ORG_ENV_CONFIG_LIST_SUCCESS, { data, totalRecords });
export const fetchOrgEnvConfigListFailed = () =>
  action(FETCH_ORG_ENV_CONFIG_LIST_FAILED);

export const fetchOrgEnvConfigListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,

    companyOutletUuid?: string,
    env_key?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchOrgEnvConfigListProgress());
      dispatch(saveLoaderProgress());

      let finalUrl = `/siteConfiguration/get-company-outlet-env?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}`;

      if (companyOutletUuid) {
        finalUrl += `&company_outlet_uuid=${companyOutletUuid}`;
      }

      if (env_key) {
        finalUrl += `&env_key=${env_key}`;
      }

      const res = await api.get(finalUrl);
      const data: IOrgEnvConfig[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchOrgEnvConfigListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchOrgEnvConfigListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const upsertOrgEnvConfigAsync =
  (
    data: IOrgEnvConfig,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/siteConfiguration/upsert-company-outlet-env", {
        ...data,
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Organization environment configuration saved succesfully!",
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_ORG_ENV_CONFIG_STATE = "CLEAR_ORG_ENV_CONFIG_STATE";

export const clearOrgEnvConfigState = () => action(CLEAR_ORG_ENV_CONFIG_STATE);
